import { Cell } from '@pelckmans/elementis/components/table';

export default function EmptyTable() {
  return (
    <table className="table">
      <thead>
        <tr>
          <Cell.HeaderEmpty />
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 8 }).map((_, index) => (
          <tr key={`row-${index}`}>
            {
              <Cell density="compact">
                <Cell.Text title="" />
              </Cell>
            }
          </tr>
        ))}
      </tbody>
    </table>
  );
}
